import { motion } from 'framer-motion';
import React from 'react';
import { Link } from 'react-router-dom';

const variants = {
  open: {
    transition: { staggerChildren: 0.1 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

const Links = ({ setOpen }) => {
  const items = ["Home", "Services", "Case Studies","Courses", "Contact", "About Us"];

  return (
    <motion.div className="links" variants={variants}>
      {items.map((item) => (
        <motion.div
          key={item}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          style={{ margin: "10px 0" }}
        >
          {/* Close menu on link click */}
          <Link
            style={{ fontSize: 30 }}
            to={`/${item.replace(/\s+/g, "").toLowerCase()}`}
            onClick={() => setOpen(false)}
          >
            {item}
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default Links;
